export const COLOR_PALLETE = {
  // White
  zWhite100: '#FFFFFF',
  zWhite200: '#F7F8FB',
  zWhite250: '#F5F5F5',

  // Grey
  zGrey200: '#F4F4FF',
  zGrey250: '#E0E5EC',
  zGrey300: '#353538',
  zGrey350: '#3D3D3D',
  zGrey400: '#88898D',
  zGrey450: '#B0B0B0',
  zGrey500: '#CCCCCC',
  zGrey550: '#595959',
  zGrey600: '#969696',
  zGrey650: '#787878',
  zGrey700: '#E3E3E3',
  zGrey750: '#CDDDF4',
  zGrey800: '#CACED4',

  // Black
  zBlack100: '#000000',
  zBlack150: '#121212',
  zBlack200: '#18191C',
  zBlack250: '#262626',
  zBlack300: '#242426',

  // MINT
  zMint400: '#8FE9C9',

  // PINK
  zPink400: '#FF99C3',

  // RED
  zRedError: '#FF2E51',
  zRed100: '#FFEBEE',
  zRed200: '#F00028',
  zRed300: '#B2001E',
  zRed400: '#7A0014',
  zRed500: '#E65B7E',
  zRed600: '#FFC7D0',
  zRed700: '#FF617B',

  // YELLOW
  zYellow500: '#FBE507',
  //  zYellow100: '#FFFF99',
  //  zYellow150: '#FBE507',
  //  zYellow200: '#FAFF6166',
  //  zYellow400: '#4D4D00',
  //  zYellow450: '#241800',
  //  zYellow500: '#242400',

  // ORANGE
  zOrange300: '#FFDD99',
  zOrange400: '#FF9870',
  zOrange500: '#FFE0D4',
  zOrange600: '#FFCA61',
  // zOrange100: '#F0A000',
  // zOrange400: '#FFDD99',
  // zOrange500: '#FFCA61',
  // zOrange600: '#FFB302',

  // PURPLE
  zPurple400: '#B3A0FF',
  // zPurple100: '#7800F0',
  // zPurple200: '#E3C7FF',
  // zPurple300: '#CC99FF',
  // zPurple400: '#962EFF',

  // BLUE
  zBlue400: '#5CA9FF',
  // zBlue100: '#EBF4FF',
  // zBlue200: '#006EF0',
  // zBlue300: '#001024',

  // GREEN
  zGreen300: '#35D348',
  zGreen400: '#8EE3B2',
  zGreen500: '#45F55A',
  zGreen550: '#45F55A66',
  // zGreen100: '#F1FFEB',
  // zGreen200: '#DAFFC7',
  // zGreen300: '#1FC59D',
  // zGreen400: '#3BB200',
  // zGreen500: '#297A00',
}
